import { render, staticRenderFns } from "./DadosCadastraisDetalhar.vue?vue&type=template&id=2290025f"
import script from "./DadosCadastraisDetalhar.vue?vue&type=script&lang=js"
export * from "./DadosCadastraisDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports